<template>
  <parallax-container class="container">
    <div v-if="this.$mq !== 'mobile'">
    <parallax-element :parallaxStrength="15" :type="'translation'" class="left-1"></parallax-element>
    <parallax-element :parallaxStrength="10" :type="'translation'" class="left-2"></parallax-element>
    <parallax-element :parallaxStrength="14" :type="'translation'" class="left-3"></parallax-element>

    <parallax-element :parallaxStrength="8" :type="'translation'" class="right-1"></parallax-element>
    <parallax-element :parallaxStrength="14" :type="'translation'" class="right-2"></parallax-element>
    <parallax-element :parallaxStrength="14" :type="'translation'" class="right-3"></parallax-element>
    <parallax-element :parallaxStrength="16" :type="'translation'" class="right-4"></parallax-element>
    </div>
    <slot></slot>
  </parallax-container>
</template>

<script>
  import parallaxContainer from "../parallax/parallax-container.vue";
  import parallaxElement from "../parallax/parallax-element.vue";

  export default {
    name: "Curtains",
    components: {
      parallaxContainer,
      parallaxElement,

    }
  }
</script>

<style scoped lang="scss">
  .container {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 1;
    overflow: auto;
  }

  .left-1 {
    position: fixed;
    height: 120vh;
    top: -10vh;
    left: -10vh;
    background-image: url("../../assets/images/curtains/gallery/left-1.png");
    background-size: cover;
    width: 33vh;
    z-index: 200;
  }

  .left-2 {
    position: fixed;
    height: 120vh;
    top: -10vh;
    left: -10vh;
    background-image: url("../../assets/images/curtains/gallery/left-2.png");
    background-size: cover;
    width: 26vh;
    z-index: 190;
  }

  .left-3 {
    position: fixed;
    height: 62vh;
    top: -10vh;
    left: -10vh;
    background-size: cover;
    width: 20vh;
    z-index: 180;
    background-image: url("../../assets/images/curtains/gallery/left-3.png");
  }

  .right-1 {
    position: fixed;
    top: -10vh;
    right: -10vh;
    background-size: cover;
    width: 28vh;
    height: 120vh;
    z-index: 200;
    background-image: url("../../assets/images/curtains/gallery/right-1.png");
  }

  .right-2 {
    position: fixed;
    top: -10vh;
    right: -10vh;
    background-size: cover;
    width: 33vh;
    height: 120vh;
    z-index: 190;
    background-image: url("../../assets/images/curtains/gallery/right-2.png");
  }

  .right-3 {
    position: fixed;
    top: -10vh;
    right: -10vh;
    background-size: cover;
    width: 19vh;
    height: 120vh;
    z-index: 180;
    background-image: url("../../assets/images/curtains/gallery/right-3.png");
  }

  .right-4 {
    position: fixed;
    top: -10vh;
    right: -10vh;
    background-size: cover;
    width: 26vh;
    height: 120vh;
    z-index: 180;
    background-image: url("../../assets/images/curtains/gallery/right-4.png");
  }

</style>